import { render, staticRenderFns } from "./modalConfirmDrafDocumentV2.vue?vue&type=template&id=1d42902c&"
import script from "./modalConfirmDrafDocumentV2.vue?vue&type=script&lang=js&"
export * from "./modalConfirmDrafDocumentV2.vue?vue&type=script&lang=js&"
import style0 from "./modalConfirmDrafDocumentV2.vue?vue&type=style&index=0&id=1d42902c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports